module.exports = __webpack_public_path__ + "img/payment_method.3ba1d60e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/payment_method.png
// module id = tr7i
// module chunks = 1